import URLHelper from "./URLHelper";
import Blackboard from "../store/Blackboard";
import plsjs from "./../index";
const uuidv4 = require("uuid/v4");

export default class LoginInitialize {
    public static async init(): Promise<void> {
        this.writeInfoOnBlackboard();
        // this.showLoading();
        let userIdFromParams = URLHelper.getUrlParams().params ? URLHelper.getUrlParams().params.logParams ?
            URLHelper.getUrlParams().params.logParams.userID : undefined : undefined;
        if (URLHelper.getUrlParams().userId || userIdFromParams) {
            await this.loginFlow();
        } else {
            await this.hardcodeActivityData();
        }
        Blackboard.setState({
            currentUser: URLHelper.getUrlParams().userId || userIdFromParams ?
                URLHelper.getUrlParams().userId || userIdFromParams : "someUserId"
        });
        await this.loadUserState();
        // this.hideLoading();
    }
    private static writeInfoOnBlackboard(): void {
        Blackboard.setState({ sessionID: uuidv4() });
        Blackboard.setState({ loggedInFromActivity: true });
    }
    private static async loginFlow(): Promise<void> {
        let urlParams = URLHelper.getUrlParams();
        let userIdFromParams = URLHelper.getUrlParams().params ? URLHelper.getUrlParams().params.logParams ?
            URLHelper.getUrlParams().params.logParams.userID : undefined : undefined;
        let userId = urlParams.userId || userIdFromParams;
        Blackboard.setState({ userId });
        let user;
        try {
            await plsjs.request.loginWithUid(userId);
        } catch (e) {
            console.warn("Logged In with a wrong user ID");
            console.log(e);
        }
    }

    private static async loadUserState(): Promise<void> {
        let state = await plsjs.request.getStudentState();
        Blackboard.loadBlackboard(state, false);
        // plsMathfluency.Blackboard.setState({ activityUid: this.activityUid });
    }

    public static showLoading(): void {
        let preloaderDiv = document.getElementById("_preload_div_");
        if (preloaderDiv) {
            preloaderDiv.style.display = "block";
        }
    }
    public static hideLoading(): void {
        let preloaderDiv = document.getElementById("_preload_div_");
        if (preloaderDiv) {
            preloaderDiv.style.display = "none";
        }
    }
    private static async hardcodeActivityData(): Promise<void> {
        let hardCodedData = {
            domainId: "BAhmtU5ZG5LkjRFCx0LW",
            email: "Nersue@gmail.com",
            refreshToken:
                "AEu4IL3zcYHBlQijaSFGoL3GUMIpIY4rbWxeEStYS5AmHfITEOMNUF_FkbHcpntgjR-c2H09o10hckdA-btB7vEZh01OcWCap-bqAnWTJB8N-h936Kn1tA8WZ9VUiW558ofXu8Um_-qe0v8D8XBCN4KwOrh3SDPf_OfUqwe84sqGoJMWYluysSX1iXWMVPPcCP2djEcm52ir1rOBN8oS5Kjt9dlOB6tKwBdQ_szbPEYqhUiSayBOWW4",
            role: "STUDENT",
            token:
                "eyJhbGciOiJSUzI1NiIsImtpZCI6IjBhZDdkNTY3ZWQ3M2M2NTEzZWQ0ZTE0ZTc4OGRjZWU4NjZlMzY3ZDMiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoibmV3VXNlciBuZXdVc2VyIiwiaXNzIjoiaHR0cHM6Ly9zZWN1cmV0b2tlbi5nb29nbGUuY29tL29tZWdhLXJoaW5vLTIyNzMxMCIsImF1ZCI6Im9tZWdhLXJoaW5vLTIyNzMxMCIsImF1dGhfdGltZSI6MTU1MjY0NTk2OCwidXNlcl9pZCI6IjQzSzF4cTRBUkJZRXREVkxqeGNxOEJrV0ZxSzIiLCJzdWIiOiI0M0sxeHE0QVJCWUV0RFZManhjcThCa1dGcUsyIiwiaWF0IjoxNTUyNjQ1OTcxLCJleHAiOjE1NTI2NDk1NzEsImVtYWlsIjoibmVyc3VlQGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJmaXJlYmFzZSI6eyJpZGVudGl0aWVzIjp7ImVtYWlsIjpbIm5lcnN1ZUBnbWFpbC5jb20iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.POApSw5_V7mK_bXPBrYovCpi2fNhD3pDG3khGnStcp7gWSyiGS0QSSCM3rdkMx6zLmUt1HiHEg9vA6jHRM3k_-FPkaGQN7QfwbWNilOAp_pxd3Wft9TXHqtDppl2VWztICH5j4bmWVRyWoBbXB0jFogs_10kIl8dczFw5wwbrL-23sVtzVnBIQUmQzdO6PiOou4c99cZ2RRLKHtTxvNQMYOOKxBZsw14YyzI4yu3oaufev2_Y6Df-2lAFdMUzgScde7cCPpxwmNu6lxf7C8pkpihU-ClSvzeWYbc31RmI_9tpJgn--wjg16bUmA5c_L4C5Yc5_KrOUavC71D-bV4Tw",
            uid: "VIHgslSAjCSzmLVOfOpu"
        };

        localStorage.setItem("credentials", JSON.stringify(hardCodedData));
        // if (this.getActivityIdFromURL()) {
        //     this.data = await plsMathfluency.Helper.ContentPropsHelper.fetchContentProps(
        //         { fbId: this.getActivityIdFromURL() }
        //     );
        // } else {
        //     this.data = this.config.activityProps;
        // }
        // this.dataID = this.data.uid;
    }
    private static getActivityIdFromURL(): string | undefined {
        return URLHelper.getUrlParams()["activityId"];
    }

}
